module.exports = __webpack_public_path__ + "static/compliance-825779adc697d644411c0b07b9c7edc2.png";